import { _ } from '@ngx-translate/core';

/**
 * Screen configuration.
 */
export enum ScreenConfiguration {

  /**
   * Standard Aspect Fixed Width.
   */
  StandardAspectFixedWidth,

  /**
   * Standard Aspect Fixed Height.
   */
  StandardAspectFixedHeight,

  /**
   * Non-Standard Aspect.
   */
  NonStandardAspect,
}

/**
 * Helper methods for Enum.
 */
export namespace ScreenConfiguration {
  const TO_TITLE_MAP: Record<ScreenConfiguration, string> = {
    [ScreenConfiguration.StandardAspectFixedWidth]: _('screen-configuration.standard-aspect-fixed-width'),
    [ScreenConfiguration.StandardAspectFixedHeight]: _('screen-configuration.standard-aspect-fixed-height'),
    [ScreenConfiguration.NonStandardAspect]: _('screen-configuration.non-standard-aspect'),
  };

  /**
   * Convert a certain Enum value to readable title.
   * @param value Value of Enum.
   */
  export function toReadable(value: ScreenConfiguration): string {
    return TO_TITLE_MAP[value];
  }

  /**
   * Get list of Enum items.
   */
  export function toArray(): ScreenConfiguration[] {
    return [
      ScreenConfiguration.StandardAspectFixedWidth,
      ScreenConfiguration.StandardAspectFixedHeight,
      ScreenConfiguration.NonStandardAspect,
    ];
  }

  /**
   * Track by function.
   */
  export function trackBy(_index: number, item: ScreenConfiguration): ScreenConfiguration {
    return item;
  }

  /**
   * Comparator for sort function.
   */
  export function sortComparator(first: ScreenConfiguration, second: ScreenConfiguration): number {
    const allItems = ScreenConfiguration.toArray();
    return allItems.indexOf(first) - allItems.indexOf(second);
  }

  /**
   * Check if selected screen configuration has fixed width.
   * @param value Value of Enum.
   */
  export function isFixedWidth(value: ScreenConfiguration | null): boolean {
    return value === ScreenConfiguration.StandardAspectFixedWidth;
  }

  /**
   * Check if selected screen configuration has fixed height.
   * @param value Value of Enum.
   */
  export function isFixedHeight(value: ScreenConfiguration | null): boolean {
    return value === ScreenConfiguration.StandardAspectFixedHeight;
  }

  /**
   * Check if selected screen configuration has non standard aspect.
   * @param value Value of Enum.
   */
  export function isNonStandardAspect(value: ScreenConfiguration | null): boolean {
    return value === ScreenConfiguration.NonStandardAspect;
  }
}
